import React, { useEffect, useState, useContext } from "react";
import PropTypes from "prop-types";
import "./styles.scss";
import { toast } from "ToastAlertContainer";
import {generalUtils} from "utilities";

const SubscribeLinkGeneratorCard = props => {
  
  let baseUrl = window.location.href[window.location.href.length - 1] == '/' ? window.location.href : window.location.href + '/'
  let urlArray = baseUrl.split("/");
  let isSubscribeLink = urlArray.includes("subscribe");
  let finalUrl = baseUrl;
  if(!isSubscribeLink){
    finalUrl = baseUrl + 'subscribe'
  }

  finalUrl = generalUtils.shortenUrlForDisplay(finalUrl)
  function copySubscribeLink() {
    navigator.clipboard.writeText(finalUrl)
    toast.success("Link copied to clipboard")
  }

  return (
    <div className="ps-subscription-link-generator-card">
      <span className={"ps-subscription-link-generator-card_title"}>
        Shareable subscribe link
      </span>
      <span className={"ps-subscription-link-generator-card_subtitle"}>
        Share the link below to allow anyone to request to receive your updates.
        Subscription requests will appear in your contacts page.
      </span>
      <div className={"ps-subscription-link-generator-card_input-box"}>
        <input
          className="input-text--primary"
          type="text"
          defaultValue={finalUrl}
        />
        <button onClick={copySubscribeLink} className={"btn ps-btn--primary ps-btn--primary-sm ml-3"}>
          Copy
        </button>
      </div>
    </div>
  );
};

export default SubscribeLinkGeneratorCard;

SubscribeLinkGeneratorCard.propTypes = {
  company: PropTypes.object,
  enableLinkToProfile: PropTypes.bool
};
